import { useMemo } from 'react'

import { useLocalisationFlowsExperimentContext } from '@src/quince-site-common/src/contexts/localisation-flow-experiement'
import { AddOnProductOptionGroup } from '@src/quince-site-common/src/domains/AddOnProductOptionGroup'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import { getDisplayKey } from '@src/utils/i18n.utils'

import { getProductLinkWithSlug } from '../../molecules/productCard/productCard.helpers'

import SiblingProductButton from './siblingProductButton/SiblingProductButton'

export enum SiblingProductOptionType {
  LINK = 'LINK',
  BUTTON = 'BUTTON',
}

interface SiblingProductOptionsProps {
  siblingProductOptionGroup: AddOnProductOptionGroup
  displayType: SiblingProductOptionType
  selectedProductOptions?: ProductVariantOption[]
  onSelect?: (val: string) => void
  selectedProductId?: number
  className?: string
  labelClassName?: string
  optionSelectorClassName?: string
  optionClassname?: string
  showNewPdpDesignV2?: boolean
}

export default function SiblingProductOptions({
  siblingProductOptionGroup,
  onSelect,
  displayType,
  selectedProductId,
  selectedProductOptions = [],
  className,
  labelClassName,
  optionSelectorClassName,
  optionClassname,
  showNewPdpDesignV2,
}: SiblingProductOptionsProps) {
  const { isNewLocalisedFlow } = useLocalisationFlowsExperimentContext()

  const selectedGroupItemLabel = useMemo(() => {
    const selectedOption = siblingProductOptionGroup.groupItems.find(groupItem => groupItem.spid === selectedProductId)
    return selectedOption
      ? getDisplayKey(
          selectedOption,
          'mergeOptionValueDisplayName',
          selectedOption.mergeOptionValue,
          isNewLocalisedFlow,
        )
      : ''
  }, [siblingProductOptionGroup.groupItems, selectedProductId])

  return (
    <div data-testid="sibling-product-options">
      <div className={className}>
        <div className={labelClassName}>
          <span>
            <span>
              {getDisplayKey(
                siblingProductOptionGroup,
                'groupOptionDisplayName',
                siblingProductOptionGroup.groupOptionName,
                isNewLocalisedFlow,
              )}
            </span>
            : {selectedGroupItemLabel}
          </span>
        </div>
        <div className={optionSelectorClassName} role="group">
          {siblingProductOptionGroup.groupItems.map((groupItem, idx) => {
            return (
              <SiblingProductButton
                id={`sibling-product-option-${idx}`}
                key={groupItem.spid}
                value={
                  displayType === SiblingProductOptionType.LINK
                    ? getProductLinkWithSlug(groupItem.productHandle, selectedProductOptions)
                    : String(groupItem.spid)
                }
                displayName={getDisplayKey(
                  groupItem,
                  'mergeOptionValueDisplayName',
                  groupItem.mergeOptionValue,
                  isNewLocalisedFlow,
                )}
                isActive={groupItem.spid === selectedProductId}
                variant={displayType}
                onClickCallback={onSelect}
                className={optionClassname}
                showNewPdpDesignV2={showNewPdpDesignV2}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
